import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { userGroupUrlCheck } from '../../../utils/userGroupUrlCheck';
import { URL_IMG } from '../../../configs/urlConfigs';
import { MSG_NOT_FOUND, MSG_SKILL_REQUIRED, MSG_SKILL_DOC_REQUIRED, MSG_SKILL_ADD_SUCCESS, MSG_SKILL_UPDATE_SUCCESS, MSG_SKILL_DELETE_SUCCESS, MSG_REQUIRED } from '../../../configs/msgConfigs';
import { LBL_APP_NAME, LBL_SETTINGS, LBL_SELECT, LBL_SKILLS, LBL_SKILL, LBL_BTN_ADDNEW, LBL_EDIT_SKILL, LBL_ADD_SKILL, LBL_BTN_SKILL_DISPLAY_INDEX, LBL_SKILL_DISPLAY_INDEX, LBL_SLNUM, LBL_CERTIFICATE_MANDATORY, LBL_CERTIFICATE_NEEDED, LBL_SHOW_DATE_RANGE, LBL_ACTIVE, LBL_ACTION, LBL_EDIT, LBL_DELETE, LBL_CONFIRM_DELETE_SKILL, LBL_IS_CERTIFICATE_MANDATORY, LBL_YES, LBL_NO, LBL_CERTIFICATE_NAME, LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS } from '../../../configs/labelConfigs';
import { LOGIN_AFFILIATE_GROUP, PAGENUMROWS_AFFILIATE, PAGING_END_INDEX, ROUTE_AFFILIATE_REFRESH, ROUTE_AFFILIATE_SETTINGS } from '../../../configs/staticConfigs'; // ROUTE_REFRESH,

import ModalWindow from '../../commons/helpers/modalWindow';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';
import SkillDisplayIndexComponent from './skillsDisplayIndexComponent';

import { formValid } from '../../../utils/validation';


import { aflt_skillListAction, aflt_skillAddAction, aflt_skillUpdateAction, aflt_skillDeleteAction, skillSuggestionAction } from '../../../actions/settings/affiliates/aflt_skillActions';
import { skillListAction } from '../../../actions/settings/superadmin/skillActions';

import { SKILL_ADD_AFFILIATE_SUCCESS, SKILL_ADD_AFFILIATE_ERROR, SKILL_UPDATE_AFFILIATE_SUCCESS, SKILL_UPDATE_AFFILIATE_ERROR, SKILL_DELETE_AFFILIATE_SUCCESS, SKILL_DELETE_AFFILIATE_ERROR, SKILL_SUGGESTION_SUCCESS, SUPERADMIN_SKILL_LIST_SUCCESS } from '../../../actions';

import { clearAction } from '../../../actions/commonActions';

class AfltSkillComponent extends Component {

    constructor(props) {
        super(props)

        let profileId = '';

        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = '';
        let grpProfileId = '';
        if (userGroupData !== undefined) {
            userGroup = userGroupData.user_group;
            grpProfileId = userGroupData.profile_id;
        }

        if (userGroup === LOGIN_AFFILIATE_GROUP) {
            profileId = grpProfileId;
        } else {
            profileId = this.props.match.params.id;
        }

        this.state = {
            formErrors: {},
            skillList: [],
            skillId: 0,
            skillName: '',
            isCertificateMandatory: '',
            certificateName: '',
            isSkillActive: true,
            skillData: {},
            formErrMsg_skillName: MSG_SKILL_REQUIRED,
            formErrMsg_CertName: '',
            formErrMsg_AddEdit: '',
            activePage: 1,
            startIndex: 0,
            endIndex: 3,
            perPageCount: PAGENUMROWS_AFFILIATE,
            activeRowId: 0,
            sortField: 'skill_name',
            sortOrder: '',
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true,
            profileId: profileId,
            displayIndexClicked: 1,
            showDateRange: false,
            masterSkillNames: [],
            superAdminSkills: [],
            superAdminSkillsAddNew: [],
            addNewSkillIds: [],
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        // this.onSort = this.onSort.bind(this);
        this.checkFormData = this.checkFormData.bind(this);
        this.modalDelete = React.createRef();
        this.modalConfirmDelete = React.createRef();
        this.modalDisplayIndex = React.createRef();
        this.modal = React.createRef();
        this.modal_BKUP = React.createRef();
    }

    setSkillName = (e) => {
        console.log(e);
    }

    reloadSkills = () => {
        this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " -  " + LBL_SKILLS + ' - Pay rates and certification';
        this.props.skillSuggestionAction('');
    }

    loadMasterSkills() {
        this.props.skillListAction({ pageSize: this.state.perPageCount, page: 0, column: 'skill_name', activeOnly: true });
    }

    openModal(refId) {
        this.loadMasterSkills();
        this.setState({ addNewSkillIds: [] });
        if (!refId) {
            this.setState({ skillId: 0, skillName: '', isCertificateMandatory: '', certificateName: '', isSkillActive: true, formErrMsg_skillName: MSG_SKILL_REQUIRED, formErrMsg_CertName: '', formErrMsg_AddEdit: '', addNewSkillIds: [] });
        }
        this.modal.current.handleOpenModal();
    }

    onModalFormReset = () => {
        this.setState({ skillId: 0, skillName: '', isCertificateMandatory: '', certificateName: '', isSkillActive: true, formErrMsg_skillName: MSG_SKILL_REQUIRED, formErrMsg_CertName: '', formErrMsg_AddEdit: '' });
        this.props.clearAction();
    }

    onModalConfirmReset = () => {
        this.modalDelete.current.handleModelClose();
        this.setState({ skillId: 0, skillName: '', isCertificateMandatory: '', certificateName: '', isSkillActive: true, formErrMsg_skillName: MSG_SKILL_REQUIRED, formErrMsg_CertName: '', formErrMsg_AddEdit: '' });
        this.props.clearAction();
    }

    openModalDisplayIndex = () => {
        let displayIndexClicked = (this.state.displayIndexClicked + 1);
        this.setState({ displayIndexClicked }, () => {
            this.modalDisplayIndex.current.handleOpenModal();
        });
    }

    onCloseToast = () => {
        this.setState({ toastFlag: false, toastMessage: '' });
    }

    setToasterState(isEnabled, message, isSucces) {
        this.setState({ toastFlag: isEnabled, toastMessage: message, toastSuccess: isSucces });
        setTimeout(() => {
            this.onCloseToast();
        }, 3000);
    }

    onShowActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');

        if (this.state.activeRowId === 0) {
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
        else if (this.state.activeRowId === rowId) {
            this.setState({ activeRowId: 0 });
        }
        else if (this.state.activeRowId !== rowId) {
            dropdown = document.getElementById('dropdown-' + this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-' + this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({ activeRowId: rowId });
            document.getElementById('img-action-' + rowId).focus();
        }
    }

    onHideActionButtons = (event, rowId) => {
        let dropdown = document.getElementById('dropdown-' + rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-' + rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({ activeRowId: 0 });
    }

    onSort = (event, sortKey) => {
        let sOrder = '';
        if (this.state.sortField === sortKey) {
            sOrder = (this.state.sortOrder === '-') ? '' : '-';
            this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: sOrder + this.state.sortField });
            this.setState({ sortOrder: sOrder });
        } else {
            this.setState({ sortField: sortKey });
            this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + sortKey });
        }
    }

    onPagePrevious = (e) => {
        const { startIndex, endIndex } = this.state
        let previousPage = startIndex + 1 - PAGING_END_INDEX
        this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: previousPage, column: this.state.sortOrder + this.state.sortField });
        if (startIndex === 0) {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: previousPage,
                startIndex: startIndex - PAGING_END_INDEX,
                endIndex: endIndex - PAGING_END_INDEX
            });
        }
    }

    onPageUp = (e) => {

        this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: e.target.id, column: this.state.sortOrder + this.state.sortField });

        this.setState({
            activePage: Number(e.target.id)
        });
    }

    onPageNext = (e) => {
        const { startIndex, endIndex } = this.state;
        const { totalPage } = this.props;
        let nextPage = startIndex + 1 + PAGING_END_INDEX;
        this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: nextPage, column: this.state.sortOrder + this.state.sortField });
        if (endIndex === totalPage || totalPage <= PAGING_END_INDEX) {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex,
                endIndex: endIndex
            });
        } else {
            this.setState({
                activePage: nextPage,
                startIndex: startIndex + PAGING_END_INDEX,
                endIndex: endIndex + PAGING_END_INDEX
            });
        }
    }

    editBtnClick = (refId) => {
        this.props.skillsList.map((rObj) => {
            if (refId === rObj.id) {
                let mand = (rObj.certificate_mandatory) ? 'yes' : 'no';
                this.setState({ skillId: refId, skillName: rObj.skill_name, basePayRate: rObj.base_pay_rate, chargeRate: rObj.charge_rate, isCertificateMandatory: mand, certificateName: rObj.certificate_name, isSkillActive: rObj.is_active, showDateRange: rObj.date_range, formErrMsg_skillName: '', formErrMsg_BPayRate: '', formErrMsg_chargeRate: '', formErrMsg_CertName: '', formErrMsg_AddEdit: '' });
                this.openModal(refId);
            }
            return console.log('.');
        });
    }

    deleteBtnClick = (rowId, name) => {
        this.setState({ skillId: rowId, skillName: name });
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () => {
        this.props.aflt_skillDeleteAction({ skillId: this.state.skillId });
    }

    onDeleteConfrimAction = () => {
        this.props.aflt_skillDeleteAction({ skillId: this.state.skillId, confirm: true });
    }

    onSelectAddnewCheckbox = (event,skillId) => { 
        let arrTemp = this.state.addNewSkillIds; 
        if(event.target.checked) {
            if(!arrTemp.includes(skillId)) {
                arrTemp.push(skillId); 
            }
            this.setState({ addNewSkillIds: arrTemp });
        }
        else {
            const index = arrTemp.indexOf(skillId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ addNewSkillIds: arrTemp });
        }            
    }
    

    onHandleChange = (event) => {
        const { name, value } = event.target;
        let dateRange = this.state.showDateRange;
        let errMsg = '';
        let valStr = value.trim();
        if (name === 'txt_skillName') {
            errMsg = valStr.length <= 0 ? MSG_SKILL_REQUIRED : '';
            this.setState({ formErrMsg_AddEdit: '', skillName: value, formErrMsg_skillName: errMsg });
        }
        else if (name === 'sel_isCertificateMandatory') {
            let cMand = (valStr === 'yes') ? true : false;
            errMsg = ((cMand) && (this.state.certificateName === '')) ? MSG_SKILL_DOC_REQUIRED : '';
            dateRange = cMand ? dateRange : false;
            this.setState({ formErrMsg_AddEdit: '', isCertificateMandatory: valStr, formErrMsg_CertName: errMsg, showDateRange: dateRange });
        }
        else if (name === 'txt_certificateName') {
            let cMand = this.state.isCertificateMandatory;
            errMsg = (cMand === 'yes') && (valStr === '') ? MSG_SKILL_DOC_REQUIRED : '';
            this.setState({ formErrMsg_AddEdit: '', certificateName: value, formErrMsg_CertName: errMsg });
        }
        else if (name === 'chk_isSkillActive') {
            let chkd = (event.target.checked) ? true : false;
            this.setState({ formErrMsg_AddEdit: '', isSkillActive: chkd });
        }
        else if (name === 'chk_showDateRange') {
            let rangeChkd = (event.target.checked) ? true : false;
            this.setState({ formErrMsg_AddEdit: '', showDateRange: rangeChkd });
        }
    }

    checkFormData() {
        if (this.state.skillName.trim() === '') {
            this.setState({ formErrMsg_AddEdit: '', formErrMsg_skillName: MSG_SKILL_REQUIRED });
            return false;
        }
        else if (this.state.isCertificateMandatory === 'yes' && this.state.certificateName.trim() === '') {
            this.setState({ formErrMsg_AddEdit: '', formErrMsg_CertName: MSG_SKILL_DOC_REQUIRED });
            return false;
        }
        else {
            return true;
        }
    }

    
    onSaveFormData = (refId) => { 
        if (this.state.addNewSkillIds && this.state.addNewSkillIds.length > 0) {
            let userGroupData = userGroupUrlCheck(this.props.location);
            let grpProfileId = '';
            if (userGroupData !== undefined) {
                grpProfileId = userGroupData.profile_id;
            }
            let affiliate = grpProfileId;
            let tmpSkillData = {
                affiliate: affiliate,
                skill_master_id:this.state.addNewSkillIds
            }
            this.props.aflt_skillAddAction(tmpSkillData);
        } else {
            // let formErrors = this.state.formErrors;
            // if(this.state.sectorData.sectorName==null){
            //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
            // }            
            // this.setState({formErrors});
        }
    }

    // onSaveFormDataBKUP = (refId) => {
    //     if (formValid(this.state)) {
    //         let userGroupData = userGroupUrlCheck(this.props.location);
    //         let grpProfileId = '';
    //         if (userGroupData !== undefined) {
    //             grpProfileId = userGroupData.profile_id;
    //         }
    //         if (refId) { // EDIT 
    //             if (this.checkFormData()) {

    //                 let affiliate = grpProfileId;
    //                 let tmpSkillData = {
    //                     id: refId,
    //                     skill_name: this.state.skillName,
    //                     certificate_name: this.state.certificateName,
    //                     certificate_mandatory: this.state.isCertificateMandatory === 'yes' ? true : false,
    //                     is_active: this.state.isSkillActive,
    //                     date_range: this.state.showDateRange,
    //                     affiliate: affiliate
    //                 }
    //                 this.props.aflt_skillUpdateAction(tmpSkillData);

    //             }
    //         } else if (this.checkFormData()) {

    //             let affiliate = grpProfileId;
    //             let tmpSkillData = {
    //                 skill_name: this.state.skillName,
    //                 certificate_name: this.state.certificateName,
    //                 certificate_mandatory: this.state.isCertificateMandatory === 'yes' ? true : false,
    //                 is_active: this.state.isSkillActive,
    //                 date_range: this.state.showDateRange,
    //                 affiliate: affiliate
    //             }
    //             this.props.aflt_skillAddAction(tmpSkillData);

    //         }
    //     } else {
    //         // let formErrors = this.state.formErrors;
    //         // if(this.state.sectorData.sectorName==null){
    //         //     formErrors.sectorName = MSG_SECTOR_REQUIRED;
    //         // }            
    //         // this.setState({formErrors});
    //     }
    // }

    componentDidUpdate(prevProps) {
        const { status, activity, numRows, totalPage, errorData, skillsMasterData, superAdminSkills, superAdminSkillsStatus, superAdminSkillsActivity } = this.props;

        if (superAdminSkillsActivity && (superAdminSkillsStatus !== prevProps.superAdminSkillsStatus || superAdminSkillsActivity !== prevProps.superAdminSkillsActivity)) {
            if (superAdminSkillsActivity === SUPERADMIN_SKILL_LIST_SUCCESS && superAdminSkills && superAdminSkills.length > 0) {
                let arrAddSkills = [];
                superAdminSkills.forEach(ssItem => {
                    if (!this.props.skillsList.find(skItem => skItem.master_skill === ssItem.id)) {
                        arrAddSkills.push(ssItem);
                    }
                    if (this.props.skillsList.find(skItem => skItem.master_skill === ssItem.id) && !this.props.skillsList.find(skItem => skItem.master_skill === ssItem.id).is_active) {
                        arrAddSkills.push(ssItem);
                    }
                });
                this.setState({ superAdminSkills: superAdminSkills, superAdminSkillsAddNew: arrAddSkills });
            }
        }

        if (activity && (status !== prevProps.status || activity !== prevProps.activity)) {
            var arrResp = activity.split('~~');
            var actString = arrResp[0];
            let errMsg = '';

            if (actString === SKILL_SUGGESTION_SUCCESS) {
                let skillsMaster = [];
                skillsMasterData.forEach(item => {
                    if (item.skill_name.length > 0) skillsMaster.push(item.skill_name);
                });
                this.setState({ masterSkillNames: skillsMaster });
            } else if (actString === SKILL_ADD_AFFILIATE_SUCCESS) {
                this.onModalFormReset();
                this.modal.current.handleModelClose();
                this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
                this.setState({ formErrMsg_AddEdit: '', toastFlag: true, toastMessage: MSG_SKILL_ADD_SUCCESS });
                setTimeout(() => { this.onCloseToast(); }, 3000);
            } else if (actString === SKILL_ADD_AFFILIATE_ERROR) {
                if (status === 400) {
                    if (errorData.hasOwnProperty('skill_name')) {
                        errMsg = errorData.skill_name[0];
                    } else {
                        this.modal.current.handleModelClose();
                        this.setToasterState(true, JSON.stringify(errorData), false);
                    }
                    this.setState({ formErrMsg_AddEdit: errMsg, formErrMsg_skillName: '', formErrMsg_BPayRate: '', formErrMsg_chargeRate: '', formErrMsg_CertName: '' });
                } else {
                    this.modal.current.handleModelClose();
                    if (errorData.hasOwnProperty('message')) {
                        this.setToasterState(true, errorData.message, false);
                    } else {
                        this.setToasterState(true, JSON.stringify(errorData), false);
                    }
                }

            } else if (actString === SKILL_UPDATE_AFFILIATE_SUCCESS) {
                this.onModalFormReset();
                this.modal.current.handleModelClose();
                this.setState({ formErrMsg_AddEdit: '', toastFlag: true, toastMessage: MSG_SKILL_UPDATE_SUCCESS });
                setTimeout(() => {
                    this.onCloseToast();
                }, 3000);
            } else if (actString === SKILL_UPDATE_AFFILIATE_ERROR) {
                if (status === 400) {
                    if (errorData.hasOwnProperty('skill_name')) {
                        errMsg = errorData.skill_name[0];
                    } else {
                        this.modal.current.handleModelClose();
                        this.setToasterState(true, JSON.stringify(errorData), false);
                    }
                    this.setState({ formErrMsg_AddEdit: errMsg, formErrMsg_skillName: '', formErrMsg_BPayRate: '', formErrMsg_chargeRate: '', formErrMsg_CertName: '' });
                } else {
                    this.modal.current.handleModelClose();
                    if (errorData.hasOwnProperty('message')) {
                        this.setToasterState(true, errorData.message, false);
                    } else {
                        this.setToasterState(true, JSON.stringify(errorData), false);
                    }
                }
            } else if (actString === SKILL_DELETE_AFFILIATE_SUCCESS) {
                this.modalDelete.current.handleModelClose();
                this.modalConfirmDelete.current.handleModelClose();

                if (numRows === 1 && totalPage > 1) {
                    let page = this.state.activePage - 1;
                    this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: page, column: this.state.sortOrder + this.state.sortField });
                } else {
                    this.props.aflt_skillListAction({ pageSize: this.state.perPageCount, page: this.state.activePage, column: this.state.sortOrder + this.state.sortField });
                }
                this.setState({ toastFlag: true, toastMessage: MSG_SKILL_DELETE_SUCCESS });
                setTimeout(() => { this.onCloseToast(); }, 3000);
            } else if (actString === SKILL_DELETE_AFFILIATE_ERROR) {
                if (status === 424) {
                    this.modalDelete.current.handleModelClose();
                    this.setToasterState(true, errorData.message, false);
                    // this.modalConfirmDelete.current.handleOpenModal();
                    // if(errorData.hasOwnProperty('confirmation_message')){
                    //     if(errorData.confirmation_message===true){
                    //         this.setState({skillId:errorData.id});
                    //     }else{
                    //         this.setState({skillId:0});
                    //     }
                    // }
                } else {
                    this.modalDelete.current.handleModelClose();
                    this.setToasterState(true, JSON.stringify(errorData), false);
                }
            }
        }
    }

    render() {
        const {
            activePage, startIndex, endIndex, toastMessage, toastFlag, toastSuccess, isCertificateMandatory, masterSkillNames, superAdminSkills, superAdminSkillsAddNew,
        } = this.state

        const { skillsList, totalPage, status } = this.props;

        if (status === 401 || status === 403) {
            return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
        }
        let disabled = false;
        if (!skillsList || !Array.isArray(skillsList) || skillsList.length < 2) {
            disabled = true
        }

        return (

            <div className="col-md-10">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className='divFloatLeft padding-left-20 padding-top-5 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
                        <div className="to-right">
                            <button className="btn btn-primary launch-modal" disabled={disabled ? true : ""} onClick={this.openModalDisplayIndex}>{LBL_BTN_SKILL_DISPLAY_INDEX}</button> &nbsp;
                            <button className="btn btn-primary launch-modal" onClick={this.openModal}>{LBL_BTN_ADDNEW}</button>
                        </div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th>{LBL_SLNUM}</th>
                                        <th>{LBL_SKILL}</th>
                                        <th>{LBL_CERTIFICATE_NAME}</th>
                                        <th className="text-center">{LBL_CERTIFICATE_MANDATORY}</th>
                                        <th className="text-center">{LBL_SHOW_DATE_RANGE}</th>
                                        <th className="text-center">{LBL_ACTIVE}</th>
                                        <th className="text-center action">{LBL_ACTION}</th>
                                        <th >&nbsp;</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {!skillsList || !Array.isArray(skillsList) || skillsList.length === 0 &&
                                        <tr>
                                            <td colSpan="12" className="text-center">{MSG_NOT_FOUND}</td>
                                        </tr>
                                    }
                                    {skillsList.map((item, index) => {
                                        return (
                                            <tr key={item.id}>
                                                <td>{(PAGENUMROWS_AFFILIATE * (this.state.activePage - 1)) + (index + 1)}</td>
                                                <td><i className={'fas '+ item.skill_icon}></i> {item.skill_name}</td>
                                                <td>{item.certificate_name}</td>
                                                <td className="text-center">{(item.certificate_mandatory) ? 'Y' : 'N'}</td>
                                                <td className="text-center">{(item.date_range) ? 'Y' : 'N'}</td>
                                                <td className="text-center">{(item.is_active) ? 'Y' : 'N'}</td>
                                                <td className="text-center">
                                                    {item.is_active && <div className="dropdown" id={'dropdown-' + item.id}>
                                                        <button className="dropdown-toggle" type="button" id={'dropdownMenuButton-' + item.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                        >
                                                            <input type="image" id={"img-action-" + item.id} src={require('../../../' + URL_IMG + 'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                        </button>
                                                        <div className="dropdown-menu marginLeft17" aria-labelledby={'dropdownMenuButton-' + item.id} id={'dropdown-menu-' + item.id}>
                                                            {/* <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link> */}
                                                            <Link className="dropdown-item delete" to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.skill_name)}>{LBL_DELETE}</Link>
                                                        </div>
                                                    </div>}
                                                </td>
                                                <td >&nbsp;</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                            <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext} />
                            <div className="clear-b-scroll-sector">&nbsp;&nbsp;</div>
                            <div className="clear-b-scroll-sector">&nbsp;&nbsp;</div>
                        </div>
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {"Are you sure you want to delete skill '" + this.state.skillName + "'?"}
                </ModalWindow>

                <ModalWindow ref={this.modalConfirmDelete} header={LBL_CONFIRM_DELETE} type="confirm" deleteConfirmedItem={this.onDeleteConfrimAction} resetModalForm={this.onModalConfirmReset}>
                    {LBL_CONFIRM_DELETE_SKILL}
                </ModalWindow>

                <ModalWindow ref={this.modalDisplayIndex} header={LBL_SKILL_DISPLAY_INDEX} resetModalForm={this.reloadSkills} noFooterButtons='yes'  >
                    <SkillDisplayIndexComponent displayIndexClicked={this.state.displayIndexClicked} skillList={this.props.skillsList}></SkillDisplayIndexComponent>
                </ModalWindow>

                <ModalWindow ref={this.modal} header={this.state.skillId ? LBL_EDIT_SKILL : LBL_ADD_SKILL} saveFormData={(e) => this.onSaveFormData(this.state.skillId)} resetModalForm={this.onModalFormReset}noFooterButtons={!superAdminSkillsAddNew || !Array.isArray(superAdminSkillsAddNew) || superAdminSkillsAddNew.length === 0 ? 'yes' : ''}>

                    <div className="row">
                        <table id="data-table" className="table" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>{LBL_SELECT}</th>
                                    <th>{LBL_SKILL}</th>
                                    <th>{LBL_CERTIFICATE_NAME}</th>
                                    <th className="text-center">{LBL_CERTIFICATE_MANDATORY}</th>
                                    <th className="text-center">{LBL_SHOW_DATE_RANGE}</th>
                                    <th >&nbsp;</th>
                                </tr>
                            </thead>

                            <tbody>

                                {!superAdminSkillsAddNew || !Array.isArray(superAdminSkillsAddNew) || superAdminSkillsAddNew.length === 0 &&
                                    <tr>
                                        <td colSpan="6" className="text-center">{MSG_NOT_FOUND}</td>
                                    </tr>
                                }

                                {superAdminSkillsAddNew.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            <td className='text-center'>
                                                <div className="form-group">
                                                    <div className="checkbox-wrapper">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_skill"+index} type="checkbox" id={"chk_skill"+index} checked={this.state.addNewSkillIds.includes(item.id) ? true : false} onChange={(e) => this.onSelectAddnewCheckbox(e,item.id)} />
                                                            <label className="checkbox" htmlFor={"chk_skill"+index}></label>
                                                            <label className="labeltext" htmlFor={"chk_skill"+index}>{''}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{item.skill_name}</td>
                                            <td>{item.certificate_name}</td>
                                            <td className="text-center">{(item.certificate_required) ? 'Y' : 'N'}</td>
                                            <td className="text-center">{(item.date_range) ? 'Y' : 'N'}</td>
                                            <td >&nbsp;</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>

                    </div>



                </ModalWindow>

                <ModalWindow ref={this.modal_BKUP} header={this.state.skillId ? LBL_EDIT_SKILL : LBL_ADD_SKILL} saveFormData={(e) => this.onSaveFormData(this.state.skillId)} resetModalForm={this.onModalFormReset}>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_SKILL}</label>
                                <div className="text-input"><input type="text" placeholder=" " name="txt_skillName" value={this.state.skillName} onChange={this.onHandleChange} maxLength={255} className={this.state.formErrMsg_skillName.length > 0 ? "input-error" : ''} list="masterSkills" autoComplete="off" />
                                    <datalist id="masterSkills" >
                                        {Array.isArray(masterSkillNames) && masterSkillNames.map((item) => {
                                            return (<option >{item}</option>);
                                        })}
                                    </datalist>
                                </div>
                                {this.state.formErrMsg_skillName.length > 0 && this.state.formErrMsg_skillName != MSG_SKILL_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_skillName}</div>
                                )}
                                {this.state.formErrMsg_AddEdit.length > 0 && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_AddEdit}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_IS_CERTIFICATE_MANDATORY}</label>
                                <div className="form-group select-input">
                                    <select name="sel_isCertificateMandatory" value={this.state.isCertificateMandatory} onChange={this.onHandleChange} >
                                        <option value="no">{LBL_NO}</option>
                                        <option value="yes" >{LBL_YES}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>{LBL_CERTIFICATE_NAME}</label>
                                <div className="text-input"><input type="text" placeholder="" name="txt_certificateName" value={this.state.certificateName} onChange={this.onHandleChange} className={this.state.formErrMsg_CertName.length > 0 ? "input-error" : ''} /></div>
                                {this.state.formErrMsg_CertName.length > 0 && this.state.formErrMsg_CertName != MSG_SKILL_DOC_REQUIRED && (
                                    <div className="text-red left-align text-12">{this.state.formErrMsg_CertName}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    {isCertificateMandatory == 'yes' &&
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <div className="checkbox-wrapper">
                                        <div className="custom-checkbox">
                                            <input name="chk_showDateRange" type="checkbox" id="chk_showDateRange" checked={this.state.showDateRange ? true : false} onChange={this.onHandleChange} />
                                            <label className="checkbox" htmlFor="chk_showDateRange"></label>
                                            <label className="labeltext" htmlFor="chk_showDateRange">{LBL_SHOW_DATE_RANGE}</label>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group">
                                <div className="checkbox-wrapper">
                                    <div className="custom-checkbox">
                                        <input type="checkbox" name="chk_isSkillActive" id="chk_isSkillActive" checked={this.state.isSkillActive ? true : false} onChange={this.onHandleChange} />
                                        <label className="checkbox" htmlFor="chk_isSkillActive"></label>
                                        <label className="labeltext" htmlFor="chk_isSkillActive">{LBL_ACTIVE}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ModalWindow>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        skillsList: state.afltSkills.items,
        totalPage: state.afltSkills.totalPage,
        skill: state.afltSkills.item,
        status: state.afltSkills.status,
        activity: state.afltSkills.activity,
        numRows: state.afltSkills.numRows,
        errorData: state.afltSkills.errorData,
        skillsMasterData: state.afltSkills.skillsMasterData,

        superAdminSkills: state.skills.items,
        superAdminSkillsStatus: state.skills.status,
        superAdminSkillsActivity: state.skills.activity,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        aflt_skillListAction: aflt_skillListAction,
        aflt_skillAddAction: data => aflt_skillAddAction(data),
        aflt_skillUpdateAction: data => aflt_skillUpdateAction(data),
        aflt_skillDeleteAction: id => aflt_skillDeleteAction(id),
        clearAction: clearAction,
        skillSuggestionAction: skillSuggestionAction,
        skillListAction: skillListAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(AfltSkillComponent);
